export const TransactionTypeAliases = {
  Payment: 'payment',
  Payout: 'payout',
  Refund: 'refund',
  Chargeback: 'chargeback',
  Cancel: 'cancel',
} as const;

export type TransactionTypeAlias =
  (typeof TransactionTypeAliases)[keyof typeof TransactionTypeAliases];

export type TransactionType = {
  id: string;
  '@id': string;
  name: string;
  alias: TransactionTypeAlias;
  description: string;
  originId: string;
};
